import React from 'react';
import { Svg } from '@tradingblock/components';
import Config from '../../config';
import { TradingEnvironment } from '../../constants';
import { IsVirtualEnvironment } from '../../data/global/selectors/environmentSelector';
import { useStateSelector } from '../../data/global/dataSelectors';

export const Logo = () => {
  const isVirtualEnv = useStateSelector(IsVirtualEnvironment);

  // Determine which logo symbol to use based on environment
  const getLogoPath = (): string => {
    // Check virtual trading first (VT)
    if (isVirtualEnv) {
      return 'icon-logo-vt';
    }
    // Then check trading environment
    switch (process.env.REACT_APP_ENVIRONMENT) {
      case TradingEnvironment.dev:
      case TradingEnvironment.local:
        return 'icon-logo-dev';
      case TradingEnvironment.beta:
        return 'icon-logo-beta';
      case TradingEnvironment.production:
      default:
        return 'icon-logo-prod';
    }
  };

  return <Svg path={getLogoPath()} label="Dashboards" />;
};
